import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white px-6 py-4" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "flex items-center justify-end mt-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, "(ID: " + _toDisplayString(_ctx.item.id) + ") " + _toDisplayString(_ctx.item.name), 1),
      _createVNode(_component_cheap, {
        class: _normalizeClass(["small ml-3", { green: _ctx.item.isMain }])
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Основной ")
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_button, {
        disabled: !_ctx.havePermissions(['contract-type-delete', 'all-root-permission']),
        loading: _ctx.state.is_deleting,
        class: "red text small",
        onClick: _ctx.deleteContractType
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Удалить ")
        ]),
        _: 1
      }, 8, ["disabled", "loading", "onClick"]),
      _createVNode(_component_the_button, {
        disabled: !_ctx.havePermissions(['contract-type-update', 'all-root-permission']),
        class: "ml-3 primary text small",
        onClick: _ctx.updateContractType
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" Редактировать ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}